import React from "react"
import { styled } from "@mui/material"
import { FooterLogo } from "./Logo"
import { useFrontendConfig } from "../../FrontendConfig"
import { useTranslations } from "@cirrus/core/i18n/provider"

export const Footer = () => {
  const { BuildDatetime } = useFrontendConfig()
  const { i18n } = useTranslations()

  const version = process.env.NODE_ENV !== "development"
    ? BuildDatetime?.slice(0, 10)
    : new Date().getMilliseconds()

  const year = new Date().getFullYear()

  return (
    <Container>
      <FooterLogo className="logo-footer-background" />
      <Text className="cirrus-copyright-text">
        {i18n("General:CopyrightText").replace("{0}", String(version)).replace("{1}", String(year))}
      </Text>
    </Container>
  )
}

const Container = styled("footer")({
  padding: "16px", display: "grid", rowGap: "16px"
})
const Text = styled("div")({
  color: "#FFFAFA", textAlign: "center", fontSize: "12px", fontWeight: 600
})